import energy1 from '../images/energy_1.jpg';
import energy2 from '../images/energy_2.jpg';
import energy3 from '../images/energy_3.jpg';
import energy4 from '../images/energy_4.jpg';
import energy5 from '../images/energy_5.jpg';
import energy6 from '../images/energy_6.jpg';
import energy7 from '../images/energy_7.jpg';
import energy8 from '../images/energy_8.jpg';
import energy9 from '../images/energy_9.jpg';
import energy10 from '../images/energy_10.jpg';
import energy11 from '../images/energy_11.jpg';
import energy12 from '../images/energy_12.jpg';
import energy13 from '../images/energy_13.jpg';
import energy14 from '../images/energy_14.jpg';
import energy15 from '../images/energy_15.jpg';
import energy16 from '../images/energy_16.jpg';
import energy17 from '../images/energy_17.jpg';
import energy18 from '../images/energy_18.jpg';
import energy19 from '../images/energy_19.jpg';
import energy20 from '../images/energy_20.jpg';
import energy21 from '../images/energy_21.jpg';
import energy22 from '../images/energy_22.jpg';
import energy23 from '../images/energy_23.jpg';

import energy_pv1 from '../images/energy_private_1.jpg';
import energy_pv2 from '../images/energy_private_2.jpg';
import energy_pv3 from '../images/energy_private_3.jpg';
import energy_pv4 from '../images/energy_private_4.jpg';
import energy_pv5 from '../images/energy_private_5.jpg';
import energy_pv6 from '../images/energy_private_6.jpg';
import energy_pv7 from '../images/energy_private_7.jpg';
import energy_pv8 from '../images/energy_private_8.jpg';
import energy_pv9 from '../images/energy_private_9.jpg';
import energy_pv10 from '../images/energy_private_10.jpg';
import energy_pv11 from '../images/energy_private_11.jpg';
import energy_pv12 from '../images/energy_private_12.jpg';
import energy_pv13 from '../images/energy_private_13.jpg';


const energy_data = {
  mpower: {
    client: "MPower Group / Advance Power", 
    title: "2.5MW Generators", 
    image_array: [
      {
        image: energy1,
        category: "energy", 
        title: '2.5MW Generators', 
        comment: "2.5MW generators by the MPower"
      },
      {
        image: energy2, 
        category: "energy", 
        title: '2.5MW Generators', 
        comment: "2.5MW generators by the MPower"
      },
      {
        image: energy3, 
        category: "energy", 
        title: '2.5MW Generators', 
        comment: "2.5MW generators by the MPower"
      },
      {
        image: energy4, 
        category: "energy", 
        title: '2.5MW Generators', 
        comment: "2.5MW generators by the MPower"
      },
      {
        image: energy5, 
        category: "energy", 
        title: '2.5MW Generators', 
        comment: "2.5MW generators by the MPower"
      },
      {
        image: energy6, 
        category: "energy", 
        title: '2.5MW Generators', 
        comment: "2.5MW generators by the MPower"
      },
      {
        image: energy7, 
        category: "energy", 
        title: '2.5MW Generators', 
        comment: "2.5MW generators by the MPower"
      },
      {
        image: energy8, 
        category: "energy", 
        title: '2.5MW Generators', 
        comment: "2.5MW generators by the MPower"
      },
      {
        image: energy9, 
        category: "energy", 
        title: '2.5MW Generators', 
        comment: "2.5MW generators by the MPower"
      },
      {
        image: energy10, 
        category: "energy", 
        title: '2.5MW Generators', 
        comment: "T2.5MW generators by the MPower"
      },
      {
        image: energy11, 
        category: "energy", 
        title: '2.5MW Generators', 
        comment: "T2.5MW generators by the MPower"
      },
      {
        image: energy12, 
        category: "energy", 
        title: '2.5MW Generators', 
        comment: "2.5MW generators by the MPower"
      },
      {
        image: energy13, 
        category: "energy", 
        title: '2.5MW Generators', 
        comment: "2.5MW generators by the MPower"
      },
      {
        image: energy14, 
        category: "energy", 
        title: '2.5MW Generators', 
        comment: "2.5MW generators by the MPower"
      },
      {
        image: energy15, 
        category: "energy", 
        title: '2.5MW Generators', 
        comment: "2.5MW generators by the MPower"
      },
      {
        image: energy16, 
        category: "energy", 
        title: '2.5MW Generators', 
        comment: "2.5MW generators by the MPower"
      },
      {
        image: energy17, 
        category: "energy", 
        title: '2.5MW Generators', 
        comment: "2.5MW generators by the MPower"
      },
      {
        image: energy18, 
        category: "energy", 
        title: '2.5MW Generators', 
        comment: "2.5MW generators by the MPower"
      },
      {
        image: energy19, 
        category: "energy", 
        title: '2.5MW Generators', 
        comment: "2.5MW generators by the MPower"
      },
      {
        image: energy20, 
        category: "energy", 
        title: '2.5MW Generators', 
        comment: "2.5MW generators by the MPower"
      },
      {
        image: energy21, 
        category: "energy", 
        title: '2.5MW Generators', 
        comment: "2.5MW generators by the MPower"
      },
      {
        image: energy22, 
        category: "energy", 
        title: '2.5MW Generators', 
        comment: "2.5MW generators by the MPower"
      },
      {
        image: energy23, 
        category: "energy", 
        title: '2.5MW Generators', 
        comment: "2.5MW generators by the MPower"
      },
    ]
  },
  private : {
    client: "Private Client", 
    title: "Portable Solar System", 
    image_array: [
      {
        image: energy_pv1,
        category: "energy", 
        title: 'Portable Solar System', 
        comment: "Portable Solar System by private client"
      },
      {
        image: energy_pv2,
        category: "energy", 
        title: 'Portable Solar System', 
        comment: "Portable Solar System by private client"
      },
      {
        image: energy_pv3,
        category: "energy", 
        title: 'Portable Solar System', 
        comment: "Portable Solar System by private client"
      },
      {
        image: energy_pv4,
        category: "energy", 
        title: 'Portable Solar System', 
        comment: "Portable Solar System by private client"
      },
      {
        image: energy_pv5,
        category: "energy", 
        title: 'Portable Solar System', 
        comment: "Portable Solar System by private client"
      },
      {
        image: energy_pv6,
        category: "energy", 
        title: 'Portable Solar System', 
        comment: "Portable Solar System by private client"
      },
      {
        image: energy_pv7,
        category: "energy", 
        title: 'Portable Solar System', 
        comment: "Portable Solar System by private client"
      },
      {
        image: energy_pv8,
        category: "energy", 
        title: 'Portable Solar System', 
        comment: "Portable Solar System by private client"
      },
      {
        image: energy_pv9,
        category: "energy", 
        title: 'Portable Solar System', 
        comment: "Portable Solar System by private client"
      },
      {
        image: energy_pv10,
        category: "energy", 
        title: 'Portable Solar System', 
        comment: "Portable Solar System by private client"
      },
      {
        image: energy_pv11,
        category: "energy", 
        title: 'Portable Solar System', 
        comment: "Portable Solar System by private client"
      },
      {
        image: energy_pv12,
        category: "energy", 
        title: 'Portable Solar System', 
        comment: "Portable Solar System by private client"
      },
      {
        image: energy_pv13,
        category: "energy", 
        title: 'Portable Solar System', 
        comment: "Portable Solar System by private client"
      },
    ]
  }
};

export default energy_data;